// Easter egg: this is the older Littlebird logo, kept for fun and whimsy on
// informational cards.
export const LittlebirdWingMarkIcon = ({
  className,
}: {
  className?: string;
}) => (
  <svg
    className={className}
    viewBox="-5.25 -2.25 22.5 22.5"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.25678 12.2508C3.30335 10.2644 3.79363 10.0738 3.86425 10.1024C3.97701 10.148 3.4939 10.8259 2.52319 13.0749C0.650313 17.4142 0.890085 17.75 1.53048 17.75C2.35084 17.75 2.25324 16.8277 3.24955 14.3973C3.54641 13.6732 3.75069 13.7165 4.26343 13.6647C7.72782 13.3147 8.89215 12.6661 9.57341 9.08215C9.79393 7.92207 9.3897 7.75239 8.20372 7.89828C7.29248 8.01037 6.99723 7.98535 6.96256 7.91886C6.82125 7.64784 8.35445 7.56467 9.57952 6.34313C10.9621 4.96449 11.3467 2.24191 11.5429 1.22434C11.7672 0.0606625 11.1678 0.226704 10.3656 0.307726C8.38945 0.507333 4.47306 1.73345 1.63435 6.42665C0.757878 7.87569 0.407725 9.12867 0.409184 9.97644C0.411028 11.0476 1.56382 13.566 2.25678 12.2508Z" />
  </svg>
);
